// extracted by mini-css-extract-plugin
export default {"FileDropZone":"FileDropZone_FileDropZone__6nl1p","over":"FileDropZone_over__dZUX8","dropZone":"FileDropZone_dropZone__hOzx9"};